export const ORGANIZATION_TYPES = [
  { text: 'Landscape Architecture', value: 'landscape architecture' },
  { text: 'Architecture', value: 'architecture' },
  { text: 'Engineering', value: 'engineering' },
  { text: 'Interdisciplinary', value: 'interdisciplinary' },
  { text: 'Sustainable Design', value: 'sustainable design' },
  { text: 'Municipality', value: 'municipality' },
  { text: 'Academic', value: 'academic' },
  { text: 'Contractor', value: 'contractor' }
]

export const INFRASTRUCTURE_CONSTRUCTION_TYPES = [
  { text: 'New Construction', value: 'new construction' },
  { text: 'Existing Asset', value: 'existing asset' },
  { text: 'Major Reconstruction', value: 'major reconstruction' },
  { text: 'Minor Renovation', value: 'minor renovation' },
  { text: 'Extension', value: 'extension' },
  { text: 'Retrofit + Extension', value: 'retrofit + extension' }
]

export const PROJECT_PHASES = [
  { text: 'Existing Condition', value: 'existing condition' },
  { text: 'Concept / Planning', value: 'concept/planning' },
  { text: 'Schematic', value: 'schematic' },
  { text: 'Design Development', value: 'design development' },
  { text: 'Construction Documentation', value: 'construction documentation' },
  { text: 'Construction (Administration)', value: 'construction (administration)' },
  { text: 'As-Built', value: 'as-built' },
  { text: 'In-Use', value: 'in-use' }
]

export const PROJECT_OWNER_TYPES = [
  { text: 'Government - Federal', value: 'government - federal' },
  { text: 'Government - State/Province', value: 'government - state/province' },
  { text: 'Government - Local', value: 'government - local' },
  { text: 'Corporate', value: 'corporate' },
  { text: 'Higher-Education', value: 'higher-education' },
  { text: 'Non-Profit', value: 'non-profit' },
  { text: 'Public-Private Partnership', value: 'public-private partnership' },
  { text: 'Investor-Developer', value: 'investor-developer' },
  { text: 'Other', value: 'other' }
]
